<template>
  <create-edit-expense class=""></create-edit-expense>
</template>

<script>
import { defineComponent } from "vue";
import CreateEditExpense from "./CreateEditExpense.vue";

export default defineComponent({
  name: "Expense",
  components: { CreateEditExpense },
  data() {
    return {};
  },
  created() {
    this.$store.commit("pmLocalModules/SET_SHOW_REQUEST_NEW_FUND", false);
    this.$store.dispatch("pmLocalModules/getAllCurrencies");
  },
});
</script>
